;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:synergiefrontends":true});}catch(e){}}();export function mapCenter(agencies): {
  lat: number;
  lng: number;
} {
  if (agencies.length === 0) return { lat: 50.7, lng: 4.257 }; // default position
  const { maxLat, minLat, maxLng, minLng } = agencies.reduce(
    (acc, curr) => {
      if (Number(curr.lat) > acc.maxLat) acc.maxLat = Number(curr.lat);
      if (Number(curr.lat) < acc.minLat) acc.minLat = Number(curr.lat);
      if (Number(curr.lng) > acc.maxLng) acc.maxLng = Number(curr.lng);
      if (Number(curr.lng) < acc.minLng) acc.minLng = Number(curr.lng);
      return acc;
    },
    {
      maxLat: -Infinity,
      minLat: Infinity,
      maxLng: -Infinity,
      minLng: Infinity,
    }
  );

  const position = { lat: (maxLat + minLat) / 2, lng: (maxLng + minLng) / 2 };

  return position;
}

export function mapZoom(agencies): number {
  if (agencies.length === 0) return 8; // default zoom level
  const { maxLat, minLat, maxLng, minLng } = agencies.reduce(
    (acc, curr) => {
      if (Number(curr.lat) > acc.maxLat) acc.maxLat = Number(curr.lat);
      if (Number(curr.lat) < acc.minLat) acc.minLat = Number(curr.lat);
      if (Number(curr.lng) > acc.maxLng) acc.maxLng = Number(curr.lng);
      if (Number(curr.lng) < acc.minLng) acc.minLng = Number(curr.lng);
      return acc;
    },
    {
      maxLat: -Infinity,
      minLat: Infinity,
      maxLng: -Infinity,
      minLng: Infinity,
    }
  );
  const latDif = maxLat - minLat;
  const lngDif = maxLng - minLng;
  let zoomLevel: number;
  if (latDif >= 0.7) zoomLevel = 8;
  else if (latDif >= 0.37 || lngDif > 0.8) zoomLevel = 9;
  else if (latDif >= 0.2 || lngDif > 0.5) zoomLevel = 10;
  else if (latDif >= 0.1 || lngDif > 0.2) zoomLevel = 11;
  else zoomLevel = 11;
  return zoomLevel;
}
